'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'deer';
var width = 512;
var height = 512;
var aliases = [129420];
var unicode = 'f78e';
var svgPathData = ['M48 264l0 17.4 27.3 27.3 4.7 4.7 0 41.2-.8 2.5-14.3 42.9 26.7 80 46.3 0-25-74.9-3.9-11.6c1.9-1.3 18.4-12.3 49.6-33l-6.3-37.8 24.7-15.9 44 29.3 83.2 0 0 144 48 0 0-169c0-6.2 .9-12.4 2.7-18.4l22-73.3 3.4-11.4 99.9 0 0-33.4-78.6-78.6-45.2 0-27.9 100.3-3.3 11.7-221.1 0c-30.9 0-56 25.1-56 56zM416 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M256 16l0-16-32 0 0 40c0 30.9 25.1 56 56 56l39.2 0c-31.1 20.8-48.9 32.6-53.3 35.6l17.8 26.6c8.8-5.9 17.8-11.9 27.1-18.1L300.7 176 96 176c-53 0-96 43-96 96l0 64 32 0 0-25.4 16 16 0 22.8-15.2 45.5-1.7 5.1 33.7 101.1 3.6 10.9 113.7 0c-1.2-3.5-12.9-38.6-35.2-105.5 30.1-20.1 45.6-30.4 46.4-31-1.1-6.6-2.3-13.8-3.6-21.8 13.7 9.1 20.8 13.9 21.3 14.2l60.8 0 0 144 112 0 0-201c0-3.1 .5-6.2 1.4-9.2l18.6-61.8 108.1 0 0-78.6-4.7-4.7-66.5-66.5C459.3 81.1 472 62 472 40l0-40-32 0 0 40c0 13.3-10.7 24-24 24l-69.4 0c3.5-7.3 5.4-15.4 5.4-24l0-40-32 0 0 40c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-24zM401.4 96l78.6 78.6 0 33.4-99.9 0-3.4 11.4-22 73.3c-1.8 6-2.7 12.2-2.7 18.4l0 169-48 0 0-144-83.2 0-44-29.3-24.7 15.9 6.3 37.8c-31.1 20.8-47.7 31.8-49.6 33l3.9 11.6 25 74.9-46.3 0-26.7-80 14.3-42.9 .8-2.5 0-41.2-4.7-4.7-27.3-27.3 0-17.4c0-30.9 25.1-56 56-56l221.1 0 3.3-11.7 27.9-100.3 45.2 0zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;